<template>
  <div class="home">
    <First5 />
  </div>
</template>

<script>
// @ is an alias to /src
import First5 from './First5.vue'

export default {
  name: 'Home',
  components: {
    First5
  }
}
</script>

<style>
.home{
  display: flex;
	flex-direction: column;
}

</style>
